import React from 'react'

const Packages = () => {
  return (
    <div>Packages</div>
  )
}

export default Packages